import UploadResumeFloating from "../UploadResumeFloating";

const JLPUploadResumeFloating = (props) => {
  return (
    <UploadResumeFloating
      signupSource={props.signupSource || "jlp_floating_resume"}
    />
  );
};

export default JLPUploadResumeFloating;